import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'
import NProgress from 'nprogress/nprogress'
import store from '@state/store'
import { allRoutes } from './routes'

Vue.use(VueRouter)
Vue.use(VueMeta, { keyName: 'page',})
var router = new VueRouter({routes: allRoutes,  mode: 'history', })

router.beforeEach((routeTo, routeFrom, next) => {
    if (routeFrom.name !== null) {
        NProgress.start()
    }
    const authRequired = routeTo.matched.some((route) => route.meta.authRequired)
    if (authRequired) 
    {
        if (store.getters['auth/loggedIn']) {
            return store.dispatch('auth/validate').then((validUser) => {
                validUser ? next() : next({ name: 'login', query: { redirectFrom: routeTo.fullPath } })
            })
        }
    }
    else
    {
        return next()
    }
})

router.beforeResolve(async (routeTo, routeFrom, next) => {
    try {
        for (const route of routeTo.matched) {
        await new Promise((resolve, reject) => {
            if (route.meta && route.meta.beforeResolve) {
            route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
                if (args.length) {
                    if (routeFrom.name === args[0].name) {
                        NProgress.done()
                    }
                    next(...args)
                    reject(new Error('Redirected'))
                } 
                else {
                    resolve()
                }
            })
            } 
            else {
                resolve()
            }
        })
        }
    } 
    catch (error) 
    {
        return
    }
    next()
})

router.afterEach((routeTo, routeFrom) => {
    NProgress.done()
})

export default router